module.exports = "/fonts/opensansextrabolditalic.ttf";